import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";

export function Signup() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [fullName, setFullName] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const { signup } = useAuth();
  const navigate = useNavigate();

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    const result = await signup(email, password, fullName);
    setLoading(false);
    if (result.success) {
      navigate("/dashboard", { replace: true });
    } else {
      setError(result.message || "Sign up failed.");
    }
  };

  return (
    <div className="min-h-[70vh] flex items-center justify-center px-4 py-16 bg-stone">
      <div className="w-full max-w-md">
        <div className="rounded-2xl border border-gray-200/80 bg-white p-8 shadow-soft-lg">
          <p className="text-gold-500 font-semibold text-xs tracking-[0.2em] uppercase">
            Get started
          </p>
          <h1 className="font-serif text-3xl font-semibold text-ink-950 tracking-tight mt-2">
            Create account
          </h1>
          <p className="mt-2 text-sm text-gray-500">
            Join to access courses and earn certificates.
          </p>
          <form onSubmit={handleSubmit} className="mt-8 space-y-5">
            <div>
              <label htmlFor="fullName" className="block text-sm font-medium text-ink-950">
                Full name
              </label>
              <input
                id="fullName"
                type="text"
                value={fullName}
                onChange={(e) => setFullName(e.target.value)}
                className="mt-1.5 w-full rounded-lg border border-gray-300 px-4 py-3 text-ink-950 placeholder-gray-400 focus:border-gold-400 focus:ring-1 focus:ring-gold-400/30 transition-colors"
                placeholder="Jane Smith"
              />
            </div>
            <div>
              <label htmlFor="email" className="block text-sm font-medium text-ink-950">
                Email
              </label>
              <input
                id="email"
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
                className="mt-1.5 w-full rounded-lg border border-gray-300 px-4 py-3 text-ink-950 placeholder-gray-400 focus:border-gold-400 focus:ring-1 focus:ring-gold-400/30 transition-colors"
                placeholder="you@example.com"
              />
            </div>
            <div>
              <label htmlFor="password" className="block text-sm font-medium text-ink-950">
                Password
              </label>
              <input
                id="password"
                type="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                required
                minLength={6}
                className="mt-1.5 w-full rounded-lg border border-gray-300 px-4 py-3 text-ink-950 placeholder-gray-400 focus:border-gold-400 focus:ring-1 focus:ring-gold-400/30 transition-colors"
                placeholder="Min. 6 characters"
              />
            </div>
            {error && (
              <p className="text-sm text-red-600 bg-red-50 px-3 py-2 rounded-lg">
                {error}
              </p>
            )}
            <button
              type="submit"
              disabled={loading}
              className="w-full rounded-lg bg-gold-400 py-3.5 text-ink-950 font-semibold tracking-wide hover:bg-gold-300 disabled:opacity-50 transition-colors shadow-md"
            >
              {loading ? "Creating account…" : "Sign up"}
            </button>
          </form>
          <p className="mt-6 text-center text-sm text-gray-600">
            Already have an account?{" "}
            <Link to="/login" className="font-semibold text-gold-500 hover:text-gold-400 transition-colors">
              Log in
            </Link>
          </p>
        </div>
      </div>
    </div>
  );
}
